(() => {

    angular.module('directives')
        .directive('match', () => ({
            require: 'ngModel',
            restrict: 'A',
            scope: {
                match: '=',
            },
            link: (scope, elem, attrs, ctrl) => {

                scope.$watch(
                    () => {

                        const modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue;

                        return (ctrl.$pristine && angular.isUndefined(modelValue)) ||
                                scope.match === modelValue;

                    },
                    (currentValue) => {

                        ctrl.$setValidity('match', currentValue);

                    },
                );

            },
        }));

})();



// WEBPACK FOOTER //
// ./scripts/directives/passMatch.js